bcn.modal = (function () {

  'use strict';

  function addModal () {
    $('[data-modal]').each(function () {
      $(this)
        .prepend('<div class="modal__bg" data-modal-close></div>')
        .prepend('<button class="modal__close" data-modal-close>Close</button>');
    });
  }

  function closeModal () {
    $('.js-modal-active').removeClass('js-modal-active').fadeOut().attr('aria-expanded', false);
    $('[data-modal-open][aria-expanded=true]').attr('aria-expanded', false);
  }

  function openModal (modal) {
    $(modal).addClass('js-modal-active').fadeIn().attr('aria-expanded', true);
  }

  return {
    init: function () {

      addModal();

      $('[data-modal-open]').on('click', function (e) {
        e.preventDefault();
        $(this).attr('aria-expanded', true);
        openModal($(this).data('modal-open'));
      });

      $('[data-modal-close]').on('click', function (el) {
        if (!$(el.target).parents().hasClass('modal__content-inner')) {
          closeModal();
        }
      });

      $(document).keyup(function(e) {
        if (e.keyCode === 27) {
          closeModal();
        }
      });

    }
  };
})();
